import { RouterStateUrl } from '@frontend/common/ph-router-store';
import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromApp from './app.reducer';

export interface State {
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
  app: fromApp.State;
}

export const reducers: ActionReducerMap<State> = {
  routerReducer: fromRouter.routerReducer,
  app: fromApp.reducer as any,
};

export const getAppState = createFeatureSelector<fromApp.State>('app');
